/* eslint-disable */
import React, { useEffect, useContext, useRef, useState } from "react";
import styled from "styled-components";
import AppContext from "../../../../context/store";

import { Grid, Column } from "../../../../theme/Grid";
import AutocompleteInput from "../../../../theme/CustomMUI/AutoComplete";
import Button from "../../../../theme/Button";
import Select from "../../../../theme/CustomMUI/Select";
import AlertDialog from "../../../../theme/CustomMUI/AlertDialog";
import DatePickerInput from "../../../../theme/CustomMUI/DatePickerInput";
import MaskedInput from "../../../../theme/CustomMUI/MaskedInput";
import { toast } from "react-toastify";
import moment from "moment";
import {
  AddBox,
  AddOutlined,
  InfoOutlined,
  Layers,
  Menu,
  Search,
} from "@material-ui/icons";
import { flushSync } from "react-dom";
import RemainingDebtRed from "../../../../assets/images/svg/remaining_debt_red.svg";
import StaffSelect from "../../../../theme/CustomMUI/StaffSelect";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import Cash from "../../../../assets/images/svg/cash.svg";
import Credit from "../../../../assets/images/svg/credit.svg";
import Transfer from "../../../../assets/images/svg/transfer.svg";
import CustomerPoint from "../../../../assets/images/svg/customer_point.svg";
import CashWhite from "../../../../assets/images/svg/cash_white.svg";
import CreditWhite from "../../../../assets/images/svg/credit_white.svg";
import CustomerPointWhite from "../../../../assets/images/svg/customer_point_white.svg";
import TransferWhite from "../../../../assets/images/svg/transfer_white.svg";
import RemainingDebt from "../../../../assets/images/svg/remaining_debt.svg";

const themeForDatePicker = createTheme({
  typography: {
    fontSize: 11,
  },
});

/**
 * Hizmet satışının yapıldığı, verilerin düzenlendiği alan.
 */
export const _ServiceSalesBuilder = ({
  checkout_data,
  lateCheckout,
  setLateCheckout,
  setCheckoutData,
  getTotalAmounts,
  setServicesDetailDialogModal,
  _service_transaction,
  setServiceTransaction,
  setSelectedStaffServices,
  staffs,
  setServiceTransactionModal,
  services,
  customer_s,
  setDiscountTarget,
  setDiscountModal,
  setDiscountValue,
  setDiscountType,
  print_dialog,
  stock_items,
  customer,
  singlePaymentAndInstallmentPayment,
  advanced_date,
  advanced_type,
  setAdvancedDate,
  setAdvancedType,
  setAdvancedStaff,
  setPaymentSelectStaff,
  payment_select_staff,
  advanced_amount,
  setAdvancedAmount,
}) => {
  const context = useContext(AppContext);
  let total_mount = 0;
  const rounded_amount = Math.round(getTotalAmounts().services);
  const [installment_dialog, setInstallmentDialog] = useState(false);
  const [installment_date, setInstallmentDate] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selected_installment, setSelectedInstallment] = useState(null);
  const [selected, setSelected] = useState(null);
  const [addPayment_dialog, setAddPaymentDialog] = useState(false);

  const getInstallmentDiffTotal = (count) => {
    const total = selected?.amount;
    return count > 0
      ? total / count
      : 0
    console.log(count);
  };


  let amountData = Object.keys(checkout_data.services).map((key) =>
    checkout_data.services[key] !== undefined
      ? checkout_data.services[key].amount !== NaN
        ? checkout_data.services[key].amount
        : 0
      : 0
  );

  for (let i = 0; i < amountData.length - 1; i++) {
    total_mount += Math.round(amountData[i]);
  }

  for (let j = 0; j < amountData.length; j++) {
    amountData[j] = Math.round(amountData[j]);
    if (amountData[amountData.length - 1]) {
      amountData[amountData.length - 1] = rounded_amount - total_mount;
    }
  }

  useEffect(() => {
    Object.keys(checkout_data.services).map((key) => {
      checkout_data.services[key] !== undefined
        ? checkout_data.services[key].amount !== NaN
          ? (checkout_data.services[key].amount = Math.round(amountData[key]))
          : 0
        : 0;
    });
  }, [checkout_data]);

  const inputRef = useRef();

  return (
    <SectionBox style={{ overflowX: "hidden" }}>
      <SectionHeading
        style={{
          backgroundColor: "rgba(13, 78, 108, 0.04)",
          color: "#3189ec",
          border: "1px solid #3189ec",
          padding: "10px",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          className="detail-search"
          style={{
            backgroundColor: "#3189ec",
          }}
          onClick={() => {
            setServicesDetailDialogModal(true);
            console.log(123);
          }}
        >
          <Search style={{ color: "white", fontSize: "20px" }} />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Layers />
          <h3 style={{ marginLeft: "15px" }}>
            {context.t(
              `['receipt/detail/id'].serviceTransactions.title`
            )}
          </h3>
        </div>
        <div>
          <AddBox
            style={{ cursor: "pointer", fontSize: "36px" }}
            onClick={() => {
              setServiceTransaction({
                ..._service_transaction,
                process_date: moment().format("YYYY-MM-DD"),
              });
              setSelectedStaffServices([
                ...staffs
                  .find(
                    (staff) =>
                      staff.id === _service_transaction.staff_id
                  )
                  .services.map((service) => service.service),
              ]);
              setServiceTransactionModal(true);
            }}
          />
        </div>
      </SectionHeading>
      <ListSection className="no-scroll-bar">
        {
          //Hizmet Listesi
          Object.keys(checkout_data.services).filter(
            (key) => checkout_data.services[key] !== undefined
          ).length > 0 ? (
            Object.keys(checkout_data.services).map(
              (key, index) =>
                checkout_data.services[key] !== undefined &&
                checkout_data.services[key].process_type !== 1 && (
                  <Grid className="no-gutters-row" key={index}>
                    <Column className="xs-12 sm-12 md-12 mt-1 lg-2">
                      <MuiThemeProvider theme={themeForDatePicker}>
                        <DatePickerInput
                          className="mb-1"
                          label={context.t(
                            `['receipt/detail/id'].serviceTransactions.dateInputLabel`
                          )}
                          error={false}
                          value={
                            moment(
                              checkout_data.services[key].process_date
                            ).format("YYYY-MM-DD") === "0001-01-01"
                              ? null
                              : moment(
                                checkout_data.services[key].process_date
                              )
                          }
                          onChange={(process_date) => {
                            setCheckoutData({
                              ...checkout_data,
                              services: {
                                ...checkout_data.services,
                                [key]: {
                                  ...checkout_data.services[key],
                                  process_date:
                                    moment(process_date).format(
                                      "YYYY-MM-DD"
                                    ),
                                },
                              }
                            });
                          }}
                        />
                      </MuiThemeProvider>
                    </Column>
                    <Column className="xs-12 sm-12 md-12 lg-3">
                      <Select
                        className="mb-1"
                        label={context.t(
                          `['receipt/detail/id'].serviceTransactions.nameInputLabel`
                        )}
                        items={staffs
                          ?.filter(
                            (staff) =>
                              staff.id ===
                              checkout_data.services[key].staff_id
                          )[0]
                          ?.services?.map((service) => service.service)
                        }
                        deletedService={staffs
                          ?.filter(
                            (staff) =>
                              staff.id ===
                              lateCheckout?.services[key]?.staff_id
                          )[0]
                          ?.services?.map((service) => service.service)?.includes(services.filter((el) => el.id === lateCheckout?.services[key]?.service_id)?.map((data) => {
                            return ({
                              ...data,
                              is_passive: true
                            })
                          })) ? [] : services?.filter((el) => el.id === lateCheckout?.services[key]?.service_id)?.map((data) => {
                            return ({
                              ...data,
                              is_passive: true
                            })
                          })}
                        serviceDisabled={true}
                        selected={
                          checkout_data?.services[key]?.service_id
                            ? services?.filter(
                              (item) =>
                                item.id ===
                                checkout_data.services[key].service_id
                            )?.length
                              ? checkout_data.services[key].service_id
                              : context.t(`["receipt/detail/id"].deletedService`)
                            : context.t(`["receipt/detail/id"].deletedService`)
                        }
                        labelKey="name"
                        valueKey="id"
                        title={
                          services.filter(
                            (item) =>
                              item.id ===
                              checkout_data.services[key].service_id
                          ).length > 0
                            ? services.filter(
                              (item) =>
                                item.id ===
                                checkout_data.services[key].service_id
                            )[0].name
                            : context.t(`["receipt/detail/id"].deletedService`)
                        }
                        handler={(service_id) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                service_id: parseInt(service_id),
                                process_type: 2,
                              },
                            }
                          });
                        }}
                      />
                    </Column>
                    <Column className="xs-12 sm-12 md-12 lg-2">
                      <StaffSelect
                        className="mb-1"
                        disabled={context.state.user.permission === 0}
                        label={context.t(
                          `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                        )}
                        items={staffs}
                        selected={
                          checkout_data.services[key].staff_id
                            ? checkout_data.services[key].staff_id
                            : ""
                        }
                        labelKey="full_name"
                        valueKey="id"
                        handler={(staff_id) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                staff_id: parseInt(staff_id),
                                process_type: 2,
                              },
                            }
                          });
                          setLateCheckout({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                staff_id: parseInt(staff_id),
                                process_type: 2,
                              },
                            }
                          })
                        }}
                      />
                    </Column>

                    <Column className="xs-12 sm-12 md-12 lg-2">
                      <Select
                        className="mb-1"
                        disabled={context.state.user.permission === 0}
                        label={context.t(`sms.deviceStatus`)}
                        items={customer_s}
                        selected={
                          checkout_data.services[key].customer_state !== null
                            ? `${checkout_data.services[key].customer_state}`
                            : ""
                        }
                        labelKey="label"
                        valueKey="value"
                        handler={(customer_state) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                customer_state: parseInt(customer_state),
                                process_type: 2,
                              },
                            }
                          });
                        }}
                      />
                    </Column>

                    <Column className="xs-12 sm-12 md-12 lg-2">
                      <MaskedInput
                        className="mb-1"
                        label={
                          context.t(
                            `['receipt/detail/id'].serviceTransactions.amountInputLabel`
                          ) +
                          (context.state.currency
                            ? " (" + context.state.currency + ")"
                            : "(₺)")
                        }
                        mask="9999999999999"
                        maskChar=""
                        value={
                          checkout_data.services[key].amount !== null
                            ? checkout_data.services[key].amount
                            : ""
                        }
                        onChange={(e) => {
                          setCheckoutData({
                            ...checkout_data,
                            services: {
                              ...checkout_data.services,
                              [key]: {
                                ...checkout_data.services[key],
                                amount: /[0-9,.]+/.test(e.target.value)
                                  ? Math.round(parseFloat(e.target.value))
                                  : null,
                                process_type: 2,
                              },
                            },
                          });
                        }}
                      />
                    </Column>
                    <Column className="xs-12 sm-12 md-12 lg-1">
                      {!checkout_data.services[key].button_passive && (
                        <Column style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start", gap: "10px", height: "100%" }}>
                          <img src={Credit} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                            setInstallmentDialog(true);
                            setSelected(checkout_data.services[key])
                          }} />
                          <img src={Cash} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                            setAddPaymentDialog(true);
                            setSelected(checkout_data.services[key])
                          }} />
                        </Column>
                      )}
                      <AlertDialog
                        title={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "5px",
                            }}
                          >
                            <AddOutlined
                              style={{
                                color: "#6097D2",
                              }}
                            />
                            <span
                              style={{
                                color: "#6097D2",
                              }}
                            >
                              {context.t(`['receipt/detail/id'].addPaymentTitle`)}
                            </span>
                          </div>
                        }
                        open={addPayment_dialog}
                        fullWidth
                        maxWidth="xs"
                        closeHandler={() => setAddPaymentDialog(false)}
                        buttons={[
                          {
                            title: context.t(
                              `appointments.create.completePaymentButtonTitle`
                            ),
                            icon: "check",
                            backgroundColor: "green",
                            style: {
                              height: "56px",
                            },
                            textColor: "white",
                            onClick: () => {
                              singlePaymentAndInstallmentPayment({
                                receipt_id: parseInt(checkout_data.receipt_id),
                                id: parseInt(checkout_data.services[key].id),
                                receipt_type: 1,
                                is_installment: false,
                                payments: [{
                                  payment_date: moment(advanced_date).format("YYYY-MM-DD"),
                                  payment_type: advanced_type,
                                  staff_id: parseInt(payment_select_staff?.staff_id),
                                  amount: parseFloat(advanced_amount),
                                  payment_status: 1,
                                }]
                              })
                              setSelected(null)
                              setSelectedInstallment(null)
                              setInstallmentDate(null)
                              setSelectedStaff(null)
                              setAdvancedDate(null)
                              setAdvancedType(0)
                              setAdvancedStaff(null)
                              setAdvancedAmount(null)
                              setPaymentSelectStaff({})
                              console.log(checkout_data.services[key])
                            },
                          },
                          {
                            title: context.t(`appointments.create.discardButtonTitle`),
                            icon: "close",
                            backgroundColor: "white",
                            style: {
                              border: "1px solid #666666",
                              height: "56px",
                            },
                            textColor: "black",
                            onClick: () => {
                              setAddPaymentDialog(false);
                              setPaymentSelectStaff({});
                              setAdvancedStaff(null);
                            },
                          },
                        ]}
                      >
                        <>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
                            </span>
                            <DatePickerInput
                              // label={context.t(
                              //   `['receipt/detail/id'].payments.dateInputLabel`
                              // )}
                              value={moment(advanced_date).local().toISOString()}
                              onChange={(payment_date) => {
                                setAdvancedDate(payment_date);
                              }}
                            />
                          </Column>
                          <Column>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <AdvancedType
                                style={{
                                  backgroundColor: advanced_type == 0 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 0
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 0
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => setAdvancedType(0)}
                              >
                                {advanced_type == 0 ? (
                                  <img src={CashWhite} alt="cash_white" />
                                ) : (
                                  <img src={Cash} alt="cash" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 0 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`accounting.typeCASH`)}
                                </span>
                              </AdvancedType>
                              <AdvancedType
                                style={{
                                  marginLeft: "10px",
                                  backgroundColor: advanced_type == 2 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 2
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 2
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => {
                                  setAdvancedType(2);
                                }}
                              >
                                {advanced_type == 2 ? (
                                  <img src={TransferWhite} alt="transfer_white" />
                                ) : (
                                  <img src={Transfer} alt="transfer" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 2 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`accounting.typeEFT`)}
                                </span>
                              </AdvancedType>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <AdvancedType
                                style={{
                                  backgroundColor: advanced_type == 1 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 1
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 1
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => {
                                  setAdvancedType(1);
                                }}
                              >
                                {advanced_type == 1 ? (
                                  <img src={CreditWhite} alt="credit_white" />
                                ) : (
                                  <img src={Credit} alt="credit" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 1 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`accounting.typeCARD`)}
                                </span>
                              </AdvancedType>
                              <AdvancedType
                                style={{
                                  marginLeft: "10px",
                                  backgroundColor: advanced_type == 3 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 3
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 3
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => {
                                  setAdvancedType(3);
                                }}
                              >
                                {advanced_type == 3 ? (
                                  <img src={CustomerPointWhite} alt="customer_point_white" />
                                ) : (
                                  <img src={CustomerPoint} alt="customer_point" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 3 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`["accounting/expense"].payments.cusPoint`)}
                                </span>
                              </AdvancedType>
                            </div>
                          </Column>
                          <Column>
                            <StaffSelect
                              disabled={context.state.user.permission === 0}
                              label={context.t(`["receipt/detail/id"].selectStaff`)}
                              items={staffs}
                              selected={payment_select_staff?.staff_id}
                              labelKey="full_name"
                              valueKey="id"
                              returnFullObject
                              handler={(staff) => {
                                setAdvancedStaff(staff);
                                setPaymentSelectStaff({
                                  ...payment_select_staff,
                                  staff_id: parseInt(staff.id),
                                });
                              }}
                            />
                          </Column>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].paymentAmount`)} *
                            </span>
                            <MaskedInput
                              // label={"Ödeme Tutarı"}
                              mask="9999999999999"
                              maskChar=""
                              value={advanced_amount ? advanced_amount : ""}
                              onChange={(e) => {
                                setAdvancedAmount(e.target.value);
                              }}
                            />
                          </Column>
                        </>
                      </AlertDialog>
                      <AlertDialog
                        title={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <span
                              style={{
                                width: "120%",
                                marginTop: "15px",
                              }}
                            >
                              {context.t(`['receipt/detail/id'].installmentProcess`)}
                            </span>
                            <CustomerBoxDiv>
                              {selected?.amount === 0 ? (
                                <img src={RemainingDebt} alt="remaining_debt" />
                              ) : (
                                <img src={RemainingDebtRed} alt="remaining_debt_red" />
                              )}
                              <CustomerPointBox>
                                <span>
                                  {getInstallmentDiffTotal(1)}{" "}
                                  {context.state.currency ? context.state.currency : "₺"}
                                </span>
                                <h3>{context.t(`['receipt/detail/id'].remainingDebt`)}</h3>
                              </CustomerPointBox>
                            </CustomerBoxDiv>
                          </div>
                        }
                        open={installment_dialog}
                        closeHandler={() => setInstallmentDialog(false)}
                        fullWidth
                        maxWidth="sm"
                        buttons={[
                          {
                            title: context.t(`appointments.create.completeButtonTitle`),
                            icon: "check",
                            backgroundColor: "green",
                            style: {
                              height: "56px",
                            },
                            textColor: "white",
                            onClick: () => {
                              singlePaymentAndInstallmentPayment({
                                receipt_id: parseInt(checkout_data.receipt_id),
                                id: parseInt(checkout_data.services[key].id),
                                receipt_type: 1,
                                is_installment: true,
                                payments: Array.from({ length: selected_installment }, (_, i) => ({
                                  payment_date:
                                    i === 0
                                      ? moment(installment_date).format("YYYY-MM-DD")
                                      : moment(installment_date)
                                        .add(i, "months")
                                        .format("YYYY-MM-DD"),
                                  payment_type: 0,
                                  staff_id: parseInt(selectedStaff),
                                  amount:
                                    getInstallmentDiffTotal(selected_installment),
                                  payment_status: 0,
                                }))
                              })
                              setSelected(null)
                              setSelectedInstallment(null)
                              setInstallmentDate(null)
                              setSelectedStaff(null)
                              setAdvancedDate(null)
                              setAdvancedType(0)
                              setAdvancedStaff(null)
                            },
                          },
                          {
                            title: context.t(`appointments.create.discardButtonTitle`),
                            icon: "close",
                            backgroundColor: "white",
                            style: {
                              border: "1px solid #666666",
                              height: "56px",
                            },
                            textColor: "black",
                            onClick: () => setInstallmentDialog(false),
                          },
                        ]}
                      >
                        <>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
                            </span>
                            <DatePickerInput
                              // label={context.t(
                              //   `['receipt/detail/id'].payments.dateInputLabel`
                              // )}
                              value={moment(installment_date).local().toISOString()}
                              onChange={(payment_date) => {
                                setInstallmentDate(payment_date);
                              }}
                            />
                          </Column>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].installmentStaffInputLabel`)} *
                            </span>
                            <StaffSelect
                              className="mb-1"
                              disabled={context.state.user.permission === 0}
                              label={context.t(
                                `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                              )}
                              items={staffs}
                              selected={selectedStaff ? selectedStaff : ""}
                              labelKey="full_name"
                              valueKey="id"
                              handler={(staff_id) => {
                                setSelectedStaff(staff_id)
                              }}
                            />
                          </Column>
                          <Column>
                            <span
                              style={{
                                marginTop: '20px !important',
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].installmentCountInputLabel`)} *
                            </span>
                            <Select
                              // label={context.t(
                              //   `['receipt/detail/id'].installmentCountInputLabel`
                              // )}
                              labelKey="label"
                              valueKey="value"
                              items={[
                                { value: 2, label: context.t(`["receipt/detail/id"].installments.two`) },
                                { value: 3, label: context.t(`["receipt/detail/id"].installments.three`) },
                                { value: 4, label: context.t(`["receipt/detail/id"].installments.four`) },
                                { value: 5, label: context.t(`["receipt/detail/id"].installments.five`) },
                                { value: 6, label: context.t(`["receipt/detail/id"].installments.six`) },
                                { value: 7, label: context.t(`["receipt/detail/id"].installments.seven`) },
                                { value: 8, label: context.t(`["receipt/detail/id"].installments.eight`) },
                                { value: 9, label: context.t(`["receipt/detail/id"].installments.nine`) },
                                { value: 10, label: context.t(`["receipt/detail/id"].installments.ten`) },
                                { value: 11, label: context.t(`["receipt/detail/id"].installments.eleven`) },
                                { value: 12, label: context.t(`["receipt/detail/id"].installments.twelve`) },
                              ]}
                              selected={selected_installment ? selected_installment : null}
                              handler={(installment) => {
                                setSelectedInstallment(installment);
                              }}
                            />
                          </Column>
                          {selected_installment && (
                            <Column>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <p style={{ marginRight: "5px" }}>{context.t(`["receipt/detail/id"].payments.title`)}:</p>
                                <p>
                                  {Math.round(getInstallmentDiffTotal(selected_installment))}
                                  {context.state.currency
                                    ? context.state.currency
                                    : "₺"} x {selected_installment}
                                </p>
                              </div>
                            </Column>
                          )}
                        </>
                      </AlertDialog>
                    </Column>
                  </Grid>
                )
            )
          ) : (
            <NoDataContainer style={{ height: "80%" }}>
              <img
                src={require("../../../../assets/images/no-data-img.png")}
                alt="Malesef bulunamadı!"
              />
              <p>
                {context.t(
                  `['receipt/detail/id'].serviceTransactions.noDataText`
                )}
              </p>
            </NoDataContainer>
          )
        }
      </ListSection>
      {Object.keys(checkout_data.services).filter(
        (key) => checkout_data.services[key] !== undefined
      ).length > 0 && (
          <SubTotalText className="mt-2">
            <CustomerBoxDiv>
              <Button
                style={{
                  border: "1px solid rgba(255, 127, 80, 0.53)",
                }}
                disabled={
                  Object.keys(checkout_data.services).filter(
                    (key) => checkout_data.services[key] !== undefined
                  ).length === 0
                }
                className="mr-2"
                icon="emoji_symbols"
                title={context.t(
                  `['receipt/detail/id'].applyDiscountButtonTitle`
                )}
                backgroundColor="orange-opacity"
                textColor="orange"
                onClick={() => {
                  if (
                    Object.keys(checkout_data.paids).filter(
                      (key) => checkout_data.paids[key] !== undefined
                    ).length === 0 &&
                    Object.keys(checkout_data.installment).filter(
                      (key) => checkout_data.installment[key] !== undefined
                    ).length === 0
                  ) {
                    setDiscountTarget("services");
                    setDiscountValue(null)
                    setDiscountType("")
                    setDiscountModal(true)
                  } else {
                    toast.warning(
                      context.t(
                        `['receipt/detail/id'].discountBeforePaymentToast`
                      )
                    );
                  }
                }}
              />
              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={RemainingDebtRed} alt="remaining_debt_red" />
                <CustomerPointBox>
                  {getTotalAmounts().services !=
                    getTotalAmounts()._fservices ? (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <p
                        style={{ textDecoration: "line-through" }}
                        className="fc-grey mr-1"
                      >
                        {getTotalAmounts()._fservices.toFixed(0)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                      <p>
                        {getTotalAmounts().services.toFixed(0)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                    </span>
                  ) : (
                    <span>
                      <p>
                        {Math.round(getTotalAmounts().services)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                    </span>
                  )}
                  <h3>
                    {context.t(
                      `['receipt/detail/id'].serviceTransactions.totalAmount`
                    )}
                  </h3>
                </CustomerPointBox>
              </div>
            </CustomerBoxDiv>
          </SubTotalText>
        )}
    </SectionBox>
  );
};

// Servis satışını eklemek için açılan dialog.

export const _ServiceSalesDialogBuilder = ({
  service_transaction,
  setServiceTransaction,
  service_transaction_modal,
  setServiceTransactionModal,
  addSingleServiceIntoCheckout,
  staffs,
  setSelectedStaffServices,
  selected_staff_services,
  searchServicesByKey,
}) => {
  const context = useContext(AppContext);

  return (
    <AlertDialog
      containerStyle={{
        overflow: "visible",
      }}
      fullWidth
      maxWidth="sm"
      title={context.t(`['receipt/detail/id'].serviceTransaction.title`)}
      open={service_transaction_modal}
      closeHandler={() => setServiceTransactionModal(false)}
      buttons={[
        {
          title: context.t(
            `['receipt/detail/id'].serviceTransaction.addButtonTitle`
          ),
          icon: "check",
          backgroundColor: "primary-opacity",
          textColor: "primary",
          onClick: () => addSingleServiceIntoCheckout(),
        },
        {
          title: context.t(
            `['receipt/detail/id'].serviceTransaction.discardButtonTitle`
          ),
          icon: "close",
          textColor: "grey",
        },
      ]}
    >
      <StaffSelect
        disabled={context.state.user.permission === 0}
        label={context.t(
          `['receipt/detail/id'].serviceTransaction.staffInputLabel`
        )}
        items={staffs}
        selected={service_transaction.staff_id}
        labelKey="full_name"
        valueKey="id"
        returnFullObject
        handler={(staff) => {
          setSelectedStaffServices([...staff.services.map((service) => service.service)]);
          setServiceTransaction({
            ...service_transaction,
            staff_id: parseInt(staff.id),
          })
        }}
      />

      <AutocompleteInput
        label={context.t(
          `['receipt/detail/id'].serviceTransaction.serviceInputLabel`
        )}
        labelKey="name"
        showField="amount"
        style={{ zIndex: "9999" }}
        // opcStyle={{ marginTop: "-80px" }}
        valueKey="id"
        selected={
          selected_staff_services !== null
            ? selected_staff_services
            : ""
        }
        onRemove={() => {
          setSelectedStaffServices(null);
          searchServicesByKey("");
        }}
        returnFullObject
        selectedHandler={(service) => {
          setServiceTransaction({
            ...service_transaction,
            service_id: parseInt(service.id),
            amount: Math.round(service.amount),
            first_amount: Math.round(service.amount),
            process_date: moment().format("YYYY-MM-DD"),
            process_type: 2,
          });
          console.log(service_transaction);
        }}
        asyncDataService={(keyword) =>
          keyword.length > 0 ? searchServicesByKey(keyword) : []
        }
        placeholder={context.t(`['receipt/detail/id'].serviceTransactions.searchPlaceholder`)}
      />
    </AlertDialog>
  );
};

const SectionBox = styled.div`
  width: 100%;
  overflow-x: scroll;
  box-sizing: border-box;
  padding-top: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  color: var(--dark-primary);

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const ListSection = styled.div`
  overflow-x: scroll;
  margin-bottom: auto;
  padding-left: 5px;
  padding-right: 5px;
`;

const SubTotalText = styled.div`
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const CustomerBoxDiv = styled.div`
  width: 100%;
  height: 57px;
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 5px;

  img {
    width: 30px;
    height: 30px;
    margin-right: 8px;
    margin-top: 7px;
    margin-left: 10px;
  }
`;

const CustomerPointBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  margin-top: 5px;

  h3 {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
    color: #3c3c3c;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;

    b {
      font-size: 13px;
      font-weight: 400;
      color: #aaa;
    }
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 16px;

  img {
    width: 100%;
    max-height: 32vh;
    object-fit: contain;
  }
  p {
    color: #407bff;
    font-size: 18px;
    font-weight: 500;
    padding-top: 16px;
    text-align: center;
  }
`;

const AdvancedType = styled.div`
  display: flex;
  width: 190px;
  height: 88px;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
`;